import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import Head from "../Global/Head";
import Header from "../Global/Header";
import { fetchData } from "../../services/getQuestions";
import Questions from "../main/stepperQuestions/Questions";
import { useNavigate } from "react-router-dom";
import StartPage from "../main/quizStartPage/StartPage";

const QuestionAnswer = () => {
  const [questions, setQuestions] = useState([]);
  const [startQuiz, setStartQuiz] = useState(false);
  const accessToken = localStorage.getItem("@user");
  const navigate = useNavigate();

  const getQuestions = async () => {
    try {
      const result = await fetchData();
      setQuestions(result?.items);
      console.log("=========>questions ", result?.items);
    } catch (error) {
      console.log("Error in fetching data====>", error);
    }
  };

  useEffect(() => {
    if (!accessToken) {
      navigate("/");
    }
  }, [accessToken, navigate]);

  return (
    <div>
      <ToastContainer />
      <Head />
      <Header />
      {!startQuiz ? (
        <StartPage
          onStart={() => {
            getQuestions();
            setStartQuiz(true);
          }}
        />
      ) : (
        <Questions quizData={questions} />
      )}
    </div>
  );
};

export default QuestionAnswer;
